
const u = navigator.userAgent
/**
 * ios环境
 */
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

/**
 * android环境
 */
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1

export const NavBarHeight = 46

// 需要鉴权token的页面
export const JWTPAGE = ["/travel_records", "/news_collection", "/myCardBag"];